<template>
  <v-container fill-height>
    <v-layout align-center>
      <v-flex>
        <v-layout justify-center wrap>
          <v-flex v-for="(app, index) in apps" :key="index" xs12 sm6 class="pa-1">
            <v-card-round hover ripple :to="app.route">
              <v-card-title class="headline font-weight-light blue-grey--text text--darken-1">
                <span class="ma-auto">{{ app.title }}</span>
              </v-card-title>
            </v-card-round>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- An aside logout button -->
    <v-logout-button />
  </v-container>
</template>

<script>
import VCardRound from "@/components/cards/CardRound";
import VLogoutButton from "./components/LogoutButton";

/**
 * A simple home view to select the app to use.
 */
export default {
  components: {
    VCardRound,
    VLogoutButton
  },
  data: () => ({
    apps: [
      {
        title: "Matching",
        route: { name: "matching" }
      },
      {
        title: "Comparador de imágenes",
        route: { name: "comparator" }
      },
      {
        title: "Clasificador",
        route: { name: "classifier" }
      },
      {
        title: "Tagueador de atributos",
        route: { name: "taggedFeatures" }
      },
      {
        title: "Mapeo de valores",
        route: { name: "valueMapping" }
      },
      {
        title: "Reglas para atributos",
        route: { name: "featureRules" }
      }
    ]
  })
};
</script>